// types.js
export const FETCH_LEAD_STATUS_REQUEST = 'FETCH_LEAD_STATUS_REQUEST'
export const FETCH_LEAD_STATUS_SUCCESS = 'FETCH_LEAD_STATUS_SUCCESS'
export const FETCH_LEAD_STATUS_FAILURE = 'FETCH_LEAD_STATUS_FAILURE'
